import fromEnum from '@/scripts/io-ts/fromEnum';

enum RecordType {
    TYPE_BASIC = 'record',
    TYPE_MOTION = 'motion',
    TYPE_UPLOAD = 'upload',
    TYPE_ZOOM = 'zoom',
    TYPE_PLAYLIST = 'playlist',
}

export const uploadingTypes = [RecordType.TYPE_UPLOAD, RecordType.TYPE_ZOOM];

export default RecordType;

export const RecordTypeC = fromEnum('RecordType', RecordType);
